module.exports = __webpack_public_path__ + "img/btn-bg-black.f435ebaf.svg";